import { render, staticRenderFns } from "./BankAccountAddress1.vue?vue&type=template&id=1e04cb48&scoped=true&"
import script from "./BankAccountAddress1.vue?vue&type=script&lang=js&"
export * from "./BankAccountAddress1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e04cb48",
  null
  
)

export default component.exports